import { render, staticRenderFns } from "./latestResults.vue?vue&type=template&id=e8fefdc4&scoped=true"
import script from "./latestResults.vue?vue&type=script&lang=js"
export * from "./latestResults.vue?vue&type=script&lang=js"
import style0 from "./latestResults.vue?vue&type=style&index=0&id=e8fefdc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fefdc4",
  null
  
)

export default component.exports